import { LocationQueryRaw } from '#vue-router';

export const createFilterList = (queryParams: LocationQueryRaw) => {
  const filters = [];

  for (const property in queryParams) {
    if (property !== 'q') {
      filters.push({
        attributeName: property,
        name: property,
        selected: Array.isArray(queryParams[property]) ? queryParams[property] : [queryParams[property]],
        type: 'distinct',
      });
    }
  }

  return filters;
};
